import { defineCollection } from "@rebasepro/common";
/**
 * Words written once and used again.
 *
 * Offered in the composer. Placeholders are filled from whoever the message is
 * to — `{{first_name}}`, `{{name}}`, `{{company}}` — and anything left unfilled
 * is flagged in the composer rather than sent: a message that opens "Hi
 * {{first_name}}," is the one kind of mistake that tells the reader exactly how
 * it was written.
 */
const emailTemplatesCollection = defineCollection({
    name: "Email templates",
    singularName: "Email template",
    slug: "email_templates",
    table: "email_templates",
    description: "Reusable messages for the composer. Placeholders: {{first_name}}, {{name}}, {{company}}.",
    properties: {
        id: { name: "ID", type: "string", isId: "uuid", admin: { readOnly: true } },
        name: { name: "Name", type: "string", validation: { required: true } },
        use: {
            name: "Offered for",
            type: "string",
            defaultValue: "any",
            enum: [
                { id: "any", label: "Anything", color: "gray" },
                { id: "reply", label: "Replies", color: "blue" },
                { id: "new", label: "New messages", color: "green" }
            ]
        },
        subject: {
            name: "Subject",
            type: "string",
            description: "Used for a new message. A reply keeps the conversation's own subject."
        },
        body: {
            name: "Message",
            type: "string",
            validation: { required: true },
            admin: { multiline: true }
        },
        created_at: { name: "Created", type: "date", autoValue: "on_create", admin: { readOnly: true } }
    },
    admin: {
        icon: "FileText",
        group: "Inbox",
        defaultViewMode: "list",
        enabledViews: ["list", "table"],
        display: {
            title: "name",
            subtitle: "subject",
            status: "use"
        },
        sort: ["name", "asc"],
        propertiesOrder: ["name", "use", "subject", "body", "created_at"]
    }
});
export default emailTemplatesCollection;
